// Styles for MerchandisingCarouselContainer go here.
import styled from 'styled-components';
import { baseVariables } from '@marriott/mi-ui-library';
import React from 'react';

export const StyledMerchandisingCarouselContainer = styled.div`
  .carousal_header--cta {
    text-wrap: nowrap;
  }
  .skeleton-loader-composite.tile-square {
    aspect-ratio: 1 / 1;
  }

  .skeleton-loader-composite.tile-wide {
    aspect-ratio: 16 / 9;
  }

  /* This is needed to override the min height when dcacontainer with riottmediacard component is authored inside merch carousel container */
  .dca-decision-container {
    [data-variation='riott-media'].dca-decision-content {
      min-height: auto;
    }
  }
  .skeleton-loader-composite.merchandising-dca-wrapper,
  .dca-decision-content {
    aspect-ratio: inherit !important;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.07);
    height: inherit;
  }

  .skeleton-loader-composite > div {
    visibility: hidden;
  }

  .card-description p {
    margin: 0;
  }

  [data-component-name='mobile-offers-preview-appTileSquare'],
  [data-component-name='mobile-offers-preview-WebMerchandisingCardTile'],
  [data-component-name='o-merch-DCADecisionContainer'],
  .glide__slides div.aem-Grid.aem-Grid--12.aem-container {
    padding: 0 !important;
    height: 100%;
  }

  .glide__arrows .left-arrow,
  .glide__arrows .right-arrow {
    width: 40px;
    height: 40px;
  }

  .glide__slides_authoring {
    width: 100% !important;
    flex-wrap: wrap;
  }

  .serverStyles {
    @media ${baseVariables.mediaQuery.sm} {
      gap: 16px;
    }
  }

  .skeleton-loader-composite {
    background-color: #d2d2d2;
    color: ${baseVariables.color.merch50};
    -webkit-animation: fadein 1s ease-in alternate infinite;
    -moz-animation: fadein 1s ease-in alternate infinite;
    animation: fadein 1s ease-in alternate infinite;
    border-radius: 8px;
  }
  @-webkit-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @-moz-keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
  @keyframes fadein {
    10% {
      opacity: 0.3;
    }
    25% {
      opacity: 0.35;
    }
    50% {
      opacity: 0.4;
    }
    75% {
      opacity: 0.5;
    }
    100% {
      opacity: 0.6;
    }
  }
`;

interface IStyledCarouselList extends React.HTMLAttributes<Partial<HTMLUListElement>> {
  ['data-cardsperview-tablet']: number;
  ['data-cardsperview-desktop']: number;
}

export const StyledCarouselList = styled.ul<IStyledCarouselList>`
  .carousel__item.skeleton-loader-composite {
    width: 100%;

    @media screen and (max-width: 576px) {
      &:nth-child(n + 2) {
        display: none;
      }
    }

    @media ${baseVariables.mediaQuery.sm} and (max-width: 992px) {
      width: ${props => 100 / Number(props['data-cardsperview-tablet'])}%;
      &:nth-child(n + ${props => Number(props['data-cardsperview-tablet'] + 1)}) {
        display: none;
      }
    }

    @media ${baseVariables.mediaQuery.lg} {
      width: ${props => 100 / Number(props['data-cardsperview-desktop'])}%;
      &:nth-child(n + ${props => Number(props['data-cardsperview-desktop']) + 1}) {
        display: none;
      }
    }
  }

  &[data-variation='tile-square'] div.merchandising-card-tile__container {
    aspect-ratio: 1 / 1;
  }

  &[data-variation='tile-wide'] div.merchandising-card-tile__container {
    aspect-ratio: 16 / 9;
  }

  &[data-variation='merchandising-dca-wrapper'] .aem-Grid.aem-Grid--12.aem-Grid--default--12.aem-container,
  .aem-GridColumn.aem-GridColumn--default--12,
  [data-component-name='o-merch-DCADecisionContainer'] {
    height: 100%;
  }

  &[data-variation='partner card'] .aem-Grid.aem-Grid--12.aem-Grid--default--12.aem-container,
  .aem-GridColumn.aem-GridColumn--default--12,
  [data-component-name='o-merch-MerchandisingPartnerCard'] {
    height: 100%;
  }
`;
